import { RegistryClient, RegistryLobbyist } from '../../types/types';
import { LobbyistRegistryIndex } from '../../data/cache';

/* The lobbyist register (meta/lobbyistRegistry) as the pages show it: labels, links and the
   register-only lobbyists (licensed, but never recorded at a committee session). */

// A register-only lobbyist's page: /lobbyists/reg-{registryId}
const REG_PREFIX = 'reg-';
export const registryIdFromParam = (param: string | undefined): string | null =>
  param && param.indexOf(REG_PREFIX) === 0 && param.length > REG_PREFIX.length ? param.slice(REG_PREFIX.length) : null;
export const registryOnlyPath = (l: RegistryLobbyist): string => `/lobbyists/${REG_PREFIX}${l.registryId}`;

// A register entry's page: our lobbyist doc when the sync matched one (and it is still in our
// list, when the caller knows the list), else the register-only page
export const registryLobbyistPath = (l: RegistryLobbyist, known?: Record<string, unknown>): string =>
  l.docId && (!known || Object.prototype.hasOwnProperty.call(known, l.docId)) ? `/lobbyists/${l.docId}` : registryOnlyPath(l);

// The register's lobbyists with no committee appearances of ours (no matched doc in `known`),
// by name
export const registryOnlyLobbyists = (reg: LobbyistRegistryIndex, known: Record<string, unknown>): RegistryLobbyist[] => {
  const out: RegistryLobbyist[] = [];
  const ids = Object.keys(reg.lobbyists);
  for (let i = 0; i < ids.length; i++) {
    const l = reg.lobbyists[ids[i]];
    if (!l.docId || !Object.prototype.hasOwnProperty.call(known, l.docId)) out.push(l);
  }
  return out.sort((a, b) => a.fullName.localeCompare(b.fullName, 'he'));
};

// The register spells some parties without the article ("ליכוד" beside "הליכוד")
const PARTY_DISPLAY: Record<string, string> = { 'ליכוד': 'הליכוד' };
export const partyDisplayName = (party: string | null | undefined): string | null => {
  const p = (party || '').trim();
  if (!p) return null;
  return Object.prototype.hasOwnProperty.call(PARTY_DISPLAY, p) ? PARTY_DISPLAY[p] : p;
};

// "ב" + a party name, as Hebrew writes it: the article drops (הליכוד → בליכוד, מרצ → במרצ)
export const inParty = (name: string): string => `ב${name.startsWith('ה') ? name.slice(1) : name}`;

export const INDEPENDENT_LABEL = 'שדלן/ית עצמאי/ת';

// The firm, or "independent" for a lobbyist the register lists without one
export const firmLabel = (l: RegistryLobbyist): string | null => l.firm || (l.independent ? INDEPENDENT_LABEL : null);

export const sortedClients = (clients: RegistryClient[]): RegistryClient[] =>
  clients.slice().sort((a, b) => a.name.localeCompare(b.name, 'he'));

export const clientsLabel = (n: number): string => (n === 1 ? 'לקוח אחד' : `${n.toLocaleString('he-IL')} לקוחות`);

export const SOURCE_NOTE = 'מקור: פנקס השדלנים של הכנסת. הלקוחות והחברות במפלגה הם הצהרות השדלן/ית בפנקס.';
